import { MissingTestComponent } from "../UI/MissingTest/MissingTestComponent.tsx";
import { IntroductionVideo } from "../User/IntroductionVideo.tsx";
import { StarIcon } from "@heroicons/react/24/outline/index.js";
import { Layout } from "../UI/Layout/Layout.tsx";
import { useTranslation } from "react-i18next";
import { useCurrentUserOrThrow } from "../Auth/useCurrentUserOrThrow.ts";
import { PerkBox } from "../UI/MissingTest/PerkBox.tsx";
import { HorizontalLineDivider } from "../UI/HorizontalLineDivider.tsx";

export const StartHereScreenPath = "/start-here";

function StartHere1on1Section() {
  const { t } = useTranslation("startHere1on1");
  const perks = [
    {
      title: t("perks.perk1.title"),
      description: t("perks.perk1.description"),
    },
    {
      title: t("perks.perk2.title"),
      description: t("perks.perk2.description"),
    },
    {
      title: t("perks.perk3.title"),
      description: t("perks.perk3.description"),
    },
    {
      title: t("perks.perk4.title"),
      description: t("perks.perk4.description"),
    },
  ];

  return (
    <div
      className={
        "sm:tablet-bubble-bg-1on1 md:desktop-bubble-bg-1on1 flex-1 p-4 flex flex-col"
      }
    >
      <div className={"max-w-[1230px] mx-auto flex flex-col flex-1"}>
        <div className={"flex-1 flex flex-col justify-center"}>
          <div className={"pb-20 pt-10 md:py-20 space-y-4"}>
            <h1 className={"font-semibold text-4xl text-center md:text-left"}>
              {t("title")}
            </h1>
            <p className={"font-light text-lg text-center md:text-left"}>
              {t("description")}
            </p>
          </div>
          <div
            className={
              "grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-14 mt-0 md:mt-32"
            }
          >
            {perks.map((p, index) => (
              <PerkBox
                key={index}
                title={p.title}
                description={p.description}
                icon={<StarIcon className={"w-6"} />}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export function StartHereScreen() {
  const { t } = useTranslation("startHere");
  const { user } = useCurrentUserOrThrow();

  function downloadURI(uri: string, name: string) {
    const link = document.createElement("a");
    link.download = name;
    link.href = uri;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  return (
    <Layout removePadding maxWClass={"max-w-full p-0"}>
      <MissingTestComponent
        backgroundClass={
          "sm:tablet-bubble-bg-no-bottom md:desktop-bubble-bg-no-bottom"
        }
        topRightComponent={
          <IntroductionVideo
            videoUrl={
              user.userGroup.slug === "teens"
                ? "https://player.vimeo.com/video/1143077740"
                : "https://player.vimeo.com/video/1003608086"
            }
          />
        }
        title={t("title")}
        description={t("description")}
        cta={{
          hide: user.userGroup.slug === "teens",
          label: t("cta"),
          action: () => {
            downloadURI(
              "https://drive.google.com/uc?export=download&id=1s6imFQXsa6x0OVVYZOtN24U7HnnorpMk",
              "Promessa a me stesso",
            );
          },
        }}
        perks={[
          {
            title: t("perks.perk1.title"),
            description: t("perks.perk1.description"),
            icon: <StarIcon className={"w-6"} />,
          },
          {
            title: t("perks.perk2.title"),
            description: t("perks.perk2.description"),
            icon: <StarIcon className={"w-6"} />,
          },
          {
            title: t("perks.perk3.title"),
            description: t("perks.perk3.description"),
            icon: <StarIcon className={"w-6"} />,
          },
        ]}
      />
      <div className={"px-4"}>
        <HorizontalLineDivider />
      </div>
      <StartHere1on1Section />
    </Layout>
  );
}
